/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetListRequest
 */
export interface GetListRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetListRequest
     */
    saids?: Array<string>;
}

/**
 * Check if a given object implements the GetListRequest interface.
 */
export function instanceOfGetListRequest(value: object): boolean {
    return true;
}

export function GetListRequestFromJSON(json: any): GetListRequest {
    return GetListRequestFromJSONTyped(json, false);
}

export function GetListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetListRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'saids': json['saids'] == null ? undefined : json['saids'],
    };
}

export function GetListRequestToJSON(value?: GetListRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'saids': value['saids'],
    };
}

